import { render, staticRenderFns } from "./ui-phone-input.vue?vue&type=template&id=26ad98a0&"
import script from "./ui-phone-input.vue?vue&type=script&lang=ts&"
export * from "./ui-phone-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports